import { t } from "@lingui/macro";
import { EducationChip } from "@WahooFitness/redesignr";

function EstimateChip({ handleClick, isManual }: { handleClick?: () => void; isManual?: boolean }) {
  return (
    <EducationChip
      key="estimate-chip"
      color="secondary"
      size="small"
      label={
        isManual
          ? t`Manual`
          : t({
              message: "Estimate",
              comment: "Noun. Label for a chip that indicates that the rider type is an estimate.",
            })
      }
      onClick={handleClick}
    />
  );
}

export default EstimateChip;
